var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "documents" },
    [
      _c("m-create-document", {
        attrs: {
          title: "Добавить документ",
          active: _vm.isShowCreateDocumentModal,
          "current-document-id": _vm.currentDocumentIdCreateDocumentModal,
        },
        on: {
          close: _vm.closeModalCreateDocument,
          submitDocument: _vm.submitDocument,
        },
      }),
      _vm.isLoadingArchive
        ? _c("c-loader", {
            attrs: {
              label: "Загружаем архив с документами",
              active: _vm.isLoadingArchive,
              height: "fixed",
            },
          })
        : _vm._e(),
      !_vm.isDataLoading
        ? _c(
            "div",
            {
              staticClass: "documents-need-add",
              class: {
                "documents-need-add-hide":
                  !_vm.isCloseAllDocumentSuccessMessage &&
                  _vm.documentsNeedAddedGroupItems.length === 0,
              },
            },
            [
              _c("div", { staticClass: "documents-need-add-title" }, [
                _vm.documentsNeedAddedGroupItems.length > 0
                  ? _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "b-toggle",
                            rawName: "v-b-toggle",
                            value: "documents-need-add-docs-group-collapse",
                            expression:
                              "'documents-need-add-docs-group-collapse'",
                          },
                        ],
                        staticClass: "documents-need-add-title-button",
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "8",
                              height: "5",
                              viewBox: "0 0 8 5",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M3.53976 4.4727C3.28126 4.21408 3.28126 3.79476 3.53976 3.53614L6.87001 0.204315C7.12851 -0.0543084 7.54762 -0.054308 7.80612 0.204315C8.06462 0.462938 8.06462 0.88225 7.80612 1.14087L4.47587 4.4727C4.21737 4.73132 3.79826 4.73132 3.53976 4.4727Z",
                                fill: "#0066FF",
                              },
                            }),
                            _c("path", {
                              attrs: {
                                d: "M4.47058 4.4727C4.72908 4.21408 4.72908 3.79476 4.47058 3.53614L1.12999 0.193967C0.871489 -0.064656 0.452377 -0.0646556 0.193876 0.193968C-0.0646252 0.452591 -0.0646252 0.871902 0.193876 1.13053L3.53447 4.4727C3.79297 4.73132 4.21208 4.73132 4.47058 4.4727Z",
                                fill: "#0066FF",
                              },
                            }),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" Необходимо добавить "),
              ]),
              _c(
                "b-collapse",
                {
                  attrs: {
                    id: "documents-need-add-docs-group-collapse",
                    visible: "",
                  },
                },
                [
                  _vm._l(_vm.documentsNeedAddedGroupItems, function (group) {
                    return _c(
                      "div",
                      {
                        key: `group-${group.name}`,
                        staticClass: "documents-need-add-docs-group",
                      },
                      [
                        _vm.documentsNeedAddedGroupItems.length > 0
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "documents-need-add-docs-group-title",
                                },
                                [_vm._v(_vm._s(group.name))]
                              ),
                              _vm._l(group.items, function (document) {
                                return _c(
                                  "div",
                                  {
                                    key: `document-${document.id}`,
                                    staticClass:
                                      "documents-need-add-docs-group-item",
                                  },
                                  [
                                    _vm.userHavePermissionAddEditDocument()
                                      ? _c("c-button", {
                                          directives: [
                                            {
                                              name: "b-popover",
                                              rawName: "v-b-popover.html",
                                              value: {
                                                container: "#app",
                                                trigger: "hover blur",
                                                content: "Добавить документ",
                                                placement: "top",
                                              },
                                              expression:
                                                "{\n                container: '#app',\n                trigger: 'hover blur',\n                content: 'Добавить документ',\n                placement: 'top',\n              }",
                                              modifiers: { html: true },
                                            },
                                          ],
                                          staticClass:
                                            "documents-need-add-docs-group-item-add",
                                          attrs: {
                                            size: "small",
                                            icon: {
                                              icon: "plus",
                                              color: "primary",
                                            },
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openModalCreateDocument(
                                                document.id
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "documents-need-add-docs-group-item-name",
                                        attrs: { title: document.name },
                                      },
                                      [_vm._v(_vm._s(document.name))]
                                    ),
                                  ],
                                  1
                                )
                              }),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  }),
                  _c("transition", { attrs: { name: "fade" } }, [
                    _vm.documentsNeedAddedGroupItems.length === 0
                      ? _c(
                          "div",
                          {
                            staticClass: "documents-need-add-all-added",
                            on: {
                              click: function ($event) {
                                _vm.isCloseAllDocumentSuccessMessage = false
                              },
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "14",
                                  height: "10",
                                  viewBox: "0 0 14 10",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M4.47288 9.68401C4.08236 9.29348 4.08236 8.66032 4.47288 8.2698L12.2929 0.449632C12.6835 0.0591074 13.3166 0.059107 13.7072 0.449631C14.0977 0.840156 14.0977 1.47332 13.7072 1.86384L5.8871 9.68401C5.49657 10.0745 4.86341 10.0745 4.47288 9.68401Z",
                                    fill: "#12C971",
                                  },
                                }),
                                _c("path", {
                                  attrs: {
                                    d: "M5.8871 9.68401C6.27762 9.29348 6.27756 8.66032 5.88704 8.2698L1.70711 4.08989C1.31658 3.69937 0.683417 3.69937 0.292893 4.08989C-0.097631 4.48042 -0.0976311 5.11358 0.292893 5.50411L4.47288 9.68401C4.86341 10.0745 5.49657 10.0745 5.8871 9.68401Z",
                                    fill: "#12C971",
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "documents-need-add-all-added-message",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "documents-need-add-all-added-message-text",
                                  },
                                  [
                                    _vm._v(
                                      "Все обязательные документы добавлены"
                                    ),
                                  ]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "documents-need-add-all-added-message-close",
                                  },
                                  [_vm._v("Закрыть")]
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      !_vm.isDataLoading && _vm.errorText === null
        ? _c(
            "div",
            {
              staticClass: "documents-content",
              class: {
                "documents-content-not-need-documents-add":
                  !_vm.isCloseAllDocumentSuccessMessage &&
                  _vm.documentsNeedAddedGroupItems.length === 0,
              },
            },
            [
              _c(
                "div",
                { staticClass: "documents-content-header" },
                [
                  _c("c-switcher", {
                    staticClass: "finance__switcher h-switcher",
                    attrs: {
                      type: "group",
                      items: [
                        { label: "Действующие", value: "acting_documents" },
                        { label: "Архив", value: "archive_documents" },
                      ],
                    },
                    model: {
                      value: _vm.switcherLocal,
                      callback: function ($$v) {
                        _vm.switcherLocal = $$v
                      },
                      expression: "switcherLocal",
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "documents-content-header-buttons" },
                    [
                      _c("c-button", {
                        staticClass: "documents-content-header-buttons-archive",
                        attrs: {
                          size: "small",
                          responsive: true,
                          disabled: _vm.archiveButtonIsDisabled,
                          icon: "box-arhive",
                          type: "with-icon",
                          label: _vm.archiveButtonLabel,
                        },
                        on: { click: _vm.changeArchiveStatus },
                      }),
                      _c("c-button", {
                        staticClass:
                          "documents-content-header-buttons-download",
                        attrs: {
                          size: "small",
                          responsive: true,
                          disabled:
                            _vm.isDisabledDownloadArchiveDocumentsButton,
                          icon: "download",
                          type: "with-icon",
                          label: "Скачать одним архивом",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.exportDocumentsToArchive(
                              _vm.switcherLocal === "acting_documents" ? 0 : 1
                            )
                          },
                        },
                      }),
                      _vm.switcherLocal === "acting_documents" &&
                      _vm.userHavePermissionAddEditDocument()
                        ? _c("c-button", {
                            staticClass:
                              "documents-content-header-buttons-add-document",
                            attrs: {
                              size: "small",
                              responsive: true,
                              icon: { icon: "plus", color: "primary" },
                              type: "with-icon",
                              label: "Добавить документ",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openModalCreateDocument(null)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "documents-content-table" },
                [
                  !_vm.isTableLoading &&
                  !_vm.isDataLoading &&
                  _vm.switcherLocal === "acting_documents"
                    ? _c("c-data-table-personal-employee-documents", {
                        ref: "table",
                        staticClass: "documents-content-table-table",
                        attrs: {
                          id: "actingDocuments",
                          "sorted-column": _vm.sortedColumn,
                          "empty-records-label": "Документы пока не добавлены",
                          levels: 1,
                          "disabled-columns": [],
                          data: _vm.tableDataActingDocuments,
                          "with-mass-operations": true,
                        },
                        on: {
                          sortedEvent: _vm.refreshTable,
                          onCheckboxesChanged: _vm.onTableCheckboxesChanged,
                          changeArchiveStatusSingle:
                            _vm.changeArchiveStatusSingle,
                        },
                      })
                    : _vm._e(),
                  !_vm.isTableLoading &&
                  !_vm.isDataLoading &&
                  _vm.switcherLocal === "archive_documents"
                    ? _c("c-data-table-personal-employee-documents", {
                        ref: "table",
                        staticClass: "documents-content-table-table",
                        attrs: {
                          id: "archiveDocuments",
                          "empty-records-label": "Документы пока не добавлены",
                          levels: 1,
                          "disabled-columns": [],
                          "sorted-column": _vm.sortedColumn,
                          data: _vm.tableDataArchiveDocuments,
                          "with-mass-operations": true,
                        },
                        on: {
                          sortedEvent: _vm.refreshTable,
                          onCheckboxesChanged: _vm.onTableCheckboxesChanged,
                          changeArchiveStatusSingle:
                            _vm.changeArchiveStatusSingle,
                        },
                      })
                    : _vm._e(),
                  _vm.isTableLoading
                    ? _c("c-loader", {
                        staticClass: "documents-content-table-loader",
                        attrs: {
                          label: "Данные загружаются",
                          active: _vm.isTableLoading,
                          height: "280",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm.isDataLoading
        ? _c("c-loader", {
            staticClass: "documents-loader",
            attrs: {
              label: "Данные загружаются",
              active: _vm.isDataLoading,
              height: "500",
            },
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "documents-content" },
        [
          _vm.errorText !== null && !_vm.isDataLoading
            ? _c("c-error-feedback", { attrs: { text: _vm.errorText } })
            : _vm._e(),
        ],
        1
      ),
      _c("u-confirm", { ref: "confirm", attrs: { id: "archive-doc" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }